import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { createHead, UnheadProvider } from '@unhead/react/client';

import { App } from '../components/app/app.jsx';

const parse = (string) => {
    return JSON.parse(string
        .replace(/<\\\/script/g, '</script')
        .replace(/<\\!--/g, '<!--'));
};

const head = createHead();
const props = parse(document.getElementById('props').innerHTML);

hydrateRoot(
    document.getElementById('js-content'),
    <>
        <UnheadProvider head={head}>
            <App {...props} />
        </UnheadProvider>
    </>
);
